<template>
  <transition name="el-fade-in">
    <div class="modal-mask" v-show="visible">
      <transition name="modal">
        <div class="modal-wrapper" v-show="visible">
          <div class="modal-wrapper-header">
            <h2>在线签约</h2>
            <i class="iconfont icondelete" @click="onClose">
              <img src="~@/assets/image/关闭.svg"/>
            </i>
          </div>
          <div class="modal-wrapper-post">
            <div class="post-content" ref="postImg">
              <div class="post-content-body">
                <div  class="goods-img" :style="{backgroundImage: `url(${Formmoney.classImg})`}" alt="" ></div>
                <div>
                   <p class="goods-name">{{Formmoney.commodityName }}</p>
                   <p v-if="Formmoney.businessId == 1" class="rules">{{Formmoney.goodsDetail || ' '}}</p>
                   <h3 v-if="Formmoney.businessId === 0 || Formmoney.businessId === '0'" class="rules" style="margin-left:5px">
                      <span>{{Formmoney.major}}, {{Formmoney.academicLevel}}</span>
                   </h3>
                   <p class="stu-name">
                     <span>报名学员</span>
                     <span>{{Formmoney.stuName}}</span>
                    </p>
                </div>
                <div class="post-content-bottom">
                  <div id="qrcode" ref="qrcode" class="qr-code"></div>
                  <div class="tips">
                    <img  style="margin-bottom:6px" src="@/assets/image/fingerprint.png" alt="">
                    <p>长按识别二维码</p>
                    <p>立即签约完成报名</p>
                  </div>
                </div>
              </div>
            
            </div>
            <div class="btn-wrap">
              <el-button style="width:112px;height:36px;" size="medium" @click="onClose">关闭</el-button>
              <el-button style="width:112px;height:35px;margin-left:20px" size="medium" type="primary" @click="getPostImg">下载海报</el-button>
          </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import QRCode from "qrcodejs2"
// import auth from "@/utils/auth"
import html2canvas from 'html2canvas'
import { formatTimesFileName } from '@/utils/timeDate'

export default {
  name: "RemoteShareModal",
  watch: {
    visible( value ){
      if( value ){
        this.Formmoney.classImg =  this.Formmoney.classImg || ''
        this.Formmoney.classImg =  "/mz_proxy?url="+encodeURI(`${this.Formmoney.classImg}?x-oss-process=image/resize,m_lfit,h_138,w_227`);
      }
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    createCode: {
      type: Object,
      required: {},
    },
    Formmoney: {
      type: Object,
      required: {}
    },
    formorder: {
      type: Object,
      required: {}
    },
    modalType: {
      type: String,
      default: 'pc'
    },
    createTime: {
      type: String
    }
  },
  data() {
    return {
      qr: null,
    }
  },
  methods: {
    // 生成二维码
    crateQrcode() {      
      // 测试线: https://mobilepay.beta.hqjy.com
      // 正式线: https://mobilepay.hqjy.com
      // 开发线： https://mobilepay.dev.hqjy.com/
    
      let params = {
        orderId: this.Formmoney.orderId,
        userId: this.Formmoney.userId && this.Formmoney.userId.trim()
      }

      this.qrcode = `${process.env.VUE_APP_QRCODE}/finishPay/success?orderId=${params.orderId}&userId=${params.userId}`
      if( this.qr && typeof this.qr.clear == 'function' ){
        this.qr.clear();
      }
      this.qr = new QRCode("qrcode", {
        width:  98,
        height: 98, // 高度
        text: this.qrcode, // 二维码内容
        correctLevel: QRCode.CorrectLevel.L
      })
      this.$refs.qrcode.title = ''//去掉QRCode库设置的title属性
    },
    onClose() {
      this.$refs.qrcode.innerHTML = ""
      this.$emit("onModalClose")
    },
    closeCollection() {
      this.$emit("closeCollection")
    },
    refreshCollection() {
      this.$emit("refreshCollection")
      document.getElementById('qrcode').innerHTML = ''
    },


    /***
     * 生成海报并且下载
     */
    getPostImg() {
      html2canvas(this.$refs.postImg, {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        scrollY: -1,
        scrollX: -3,
        width: this.$refs.postImg.clientWidth,
        height: this.$refs.postImg.clientHeight,
        scale: window.devicePixelRatio,
      }).then(canvas => {
        // 转成图片，生成图片地址
        let imgUrl = canvas.toDataURL('image/png');
        const eleLink = document.createElement('a');
        eleLink.href = imgUrl; // 转换后的图片地址
        // 文件名 商品名-班型名-签约_学员姓名_报名时间
        // eleLink.download = '收款海报'
        eleLink.download = `${this.Formmoney.commodityName}-${this.Formmoney.goodsDetail}-签约_${this.Formmoney.stuName}_${formatTimesFileName(this.createTime)}`
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
      });
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .modal-wrapper {
    width: 676px;
    background: #fff;
    border-radius: 6px;
    &-header {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 60px;
      padding-left: 30px;
      border-bottom: 1px solid #e1e4eb;
      > h2 {
        margin-right: 12px;
        font-size: 16px;
        font-weight: 700;
        color: #333;
        > span {
          font-size: 14px;
          font-weight: 400;
          color: #999999;
        }
      }
      > p {
        font-size: 14px;
        color: #999;
      }
      > i {
        position: absolute;
        right: 30px;
        font-size: 18px;
        color: #9bacbf;
        cursor: pointer;
        transition: 0.3s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
    &-body {

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 50px 60px 50px 60px;
      &-left {
        font-size: 14px;
        color: #666;
        line-height: 21px;
        margin-right: 60px;
        &>h3 {
          margin-bottom: 16px;
          line-height: 30px;
          &>span:first-child {
            display: inline-block;
            text-align: right;
          }
          &>span:last-child {
            color: #333;
          }
          .money {
            color: #F54955 !important;
            font-size: 20px;
            font-weight: bold;
          }
        }
      }



      &-right {
        width: 209px;
        height: 372px;
        opacity: 0.73;
        background: rgba(230,246,242,0.43);
        position: relative;

        #qrcode {
          background: contain;
          overflow: hidden;
        }
        .qrcode-text {
          position: absolute;
          bottom: 10px;
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #333;
          line-height: 16px;
          letter-spacing: 1px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 5px;
          &>img {
            width: 24px;
            height: 24px;
          }
          &>span {
            font-size: 12px;
            text-align: center;
            color: #777777;
            line-height: 16px;
            letter-spacing: 1px;
            margin-left: 9px;
          }
        }
      }

    }
    .btns {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
    }

    .post-content-header {
      padding: 12px 20px 8px;
      display: flex;
      align-items: center;
      .logo {
          width: 40px;
          height: 40px;
          margin-right: 12px;
          object-fit: contain;
          border: 1px solid #eee;
          border-radius: 20px;
      }
      .title,.space {
        font-size: 14px;
        color: #222;
      }
      .space {
        padding: 0 8px;
      }
      .tip {
        color: #666;
        font-size: 12px;
      }  

    }

    .post-content-body {
      height: 460px;
      position: relative;
      padding: 70px 15px 36px;

      .goods-img {
          margin: 0 12px;
          width:232px;
          height:112px;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100%;
          // background-size: cover;
      }
      
      .goods-name {
        padding: 5px 12px 10px;
        line-height: 18px;
        font-size: 12px;
        color: #333;
        margin-bottom: 0;
      }
      .rules {
        color: #777;
        padding: 4px 12px 10px;
        font-size: 10px;
        line-height: 16px;
        max-height: 7em;
        margin-bottom: 0;
        overflow: hidden;
        // display: -webkit-box;
        // -webkit-box-orient: vertical;
        // -webkit-line-clamp: 2;
        // overflow: hidden;
        // text-overflow: ellipsis;
      }
      .stu-name {
        margin: 0 12px;
        border: 1px solid #eee;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #F0FAFA;
         font-size: 12px;
         border-radius: 4px;
        span:first-child {
          color: #666;
          margin-right: 10px;
        }
        span {
          margin-left: 10px;
          color:#337AFF
        }
       
      }
    }

    .post-content-bottom {
      position: absolute;
      bottom: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 18px;
      margin-bottom: 14px;
       #qrcode {
          width: 100px;
          height: 100px;
          border: 1px solid #eee;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          overflow: hidden;
     }

     .tips {
          display: flex;
          flex-direction: column;
          position: relative;
          // padding-bottom: 31px;
          margin-left: 25px;
          margin-top: 5px;
          > img {
            width: 38px;
            height: 38px;
            margin: 0 auto;
          }
          p {
            line-height: 20px;
            font-size: 12px;
            color: #666;
          }
      }
    }

   

    &-post {
      padding: 20px 0 0 0;
      .post-content {
        width: 284px;
        height: 504px;
        background: url('../../../../assets/image/online-subscript.png') no-repeat;
        background-size:cover;
        margin: 0px auto;
      }
      .refresh-qrcode {
        position: absolute;
        bottom: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        user-select: none;
        cursor: pointer;
        left: 0;
        > img {
          width: 15px;
          height: 15px;
          transition: 0.3s ease;
          &:hover {
            transform: rotate(180deg);
          }
        }
        > span {
          font-size: 12px;
          font-weight: 400;
          color: #777777;
          margin-left: 15px;
        }
      }
      .btn-wrap {
          border: 1px solid #E1E4EB;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 18px 0 20px;
          margin-top: 18px;

      }
    }
  }
}
</style>
